import React from 'react'
import { Badge } from 'reactstrap'

export default function FiltroSelecionado({element, index}){
    return(
        <Badge pill style={{padding: '7px', color: 'black', background: 'white', border: '1px solid var(--color-roxo)'}}>
                {element.descricao === '1' ? 'Data Status' : element.descricao === '0' ? 'Data Entrada' : element.descricao}
        </Badge>
    )
}